import * as React from "react";
import { BetBtnOdd } from "./BetBtnOdd";
import { BetBtnMlQa } from "./BetBtnMlQa";
import { BetBtnOuHc } from "./BetBtnOuHc";
// TODO: TYPE UP THE ADD TO BET SLIP FUNCTIONS
export var BetBtnTypes;
(function (BetBtnTypes) {
    BetBtnTypes["Odd"] = "bet_btn--Odd";
    BetBtnTypes["ML"] = "bet_btn--ML";
    BetBtnTypes["QA"] = "bet_btn--QA";
    BetBtnTypes["OU"] = "bet_btn--OU";
    BetBtnTypes["HC"] = "bet_btn--HC";
})(BetBtnTypes || (BetBtnTypes = {}));
/* eslint react/display-name: "off" */
const BetBtnsMap = {
    [BetBtnTypes.Odd]: (props) => (React.createElement(BetBtnOdd, { odd: props.odd, dataUat: props.betButtonInnerDataUats })),
    [BetBtnTypes.ML]: (props) => (React.createElement(BetBtnMlQa, { text: props.text, odd: props.odd, dataUat: props.betButtonInnerDataUats })),
    [BetBtnTypes.QA]: (props) => (React.createElement(BetBtnMlQa, { text: props.text, odd: props.odd, dataUat: props.betButtonInnerDataUats })),
    [BetBtnTypes.OU]: (props) => (React.createElement(BetBtnOuHc, { text: props.text, point: props.point, odd: props.odd, dataUat: props.betButtonInnerDataUats })),
    [BetBtnTypes.HC]: (props) => (React.createElement(BetBtnOuHc, { text: props.text, point: props.point, odd: props.odd, dataUat: props.betButtonInnerDataUats }))
};
/* eslint @typescript-eslint/ban-types: "off" */
export class BetBtn extends React.Component {
    constructor() {
        super(...arguments);
        this.fnRouter = () => ((typeof this.props.handler !== "function" ? this.noop : this.props.handler)());
    }
    noop() { return false; }
    render() {
        const cls = `bet_btn${this.props.modifier ? ` ${this.props.modifier}` : ""}`;
        const childrenFn = (this.props.type && typeof BetBtnsMap[this.props.type] === "function") ?
            BetBtnsMap[this.props.type] :
            BetBtnsMap[BetBtnTypes.Odd];
        return (React.createElement("button", { "btn-type": this.props.type, className: cls, onClick: this.fnRouter, disabled: this.props.isDisabled, "data-uat": this.props.dataUat }, childrenFn(this.props)));
    }
}
//# sourceMappingURL=BetBtn.js.map